import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactElement } from "react";
import { Tooltip } from "react-tooltip";
interface DropVoteProgressingProps {
  readonly current: number | null | undefined;
  readonly projected: number | null | undefined;
  readonly subtle?: boolean | undefined;
  readonly compact?: boolean | undefined;
  readonly tooltipLabel?: string | undefined;
}
export default function DropVoteProgressing(t0) {
  const $ = _c(23);
  const {
    current,
    projected,
    subtle: t1,
    compact: t2,
    tooltipLabel: t3
  } = t0;
  const subtle = t1 === undefined ? false : t1;
  const compact = t2 === undefined ? false : t2;
  const tooltipLabel = t3 === undefined ? "Projected vote count at decision time" : t3;
  if (typeof current !== "number" || typeof projected !== "number") {
    return null;
  }
  const isProgressing = current !== projected;
  if (!isProgressing) {
    return null;
  }
  const isPositiveProgressing = current < projected;
  let color;
  let arrowColor;
  let wrapperClasses;
  let valueClasses;
  if (subtle) {
    color = isPositiveProgressing ? "tw-text-iron-400 tw-font-mono" : "tw-text-iron-600 tw-font-mono";
    arrowColor = "tw-text-iron-600";
    wrapperClasses = "tw-flex tw-items-center tw-gap-2";
    valueClasses = "tw-text-sm tw-font-bold tw-tracking-tight";
  } else {
    if (compact) {
      color = isPositiveProgressing ? "tw-text-emerald-400 tw-bg-emerald-500/10 tw-px-1.5 tw-py-0.5 tw-rounded-md tw-border tw-border-solid tw-border-emerald-500/15" : "tw-text-rose-400 tw-bg-rose-500/10 tw-px-1.5 tw-py-0.5 tw-rounded-md tw-border tw-border-solid tw-border-rose-500/15";
      arrowColor = "tw-text-iron-500";
      wrapperClasses = "tw-ml-0.5 tw-flex tw-items-center tw-gap-1.5";
      valueClasses = "tw-text-sm tw-font-bold tw-leading-5 tw-tabular-nums";
    } else {
      color = isPositiveProgressing ? "tw-text-emerald-500 tw-bg-emerald-500/10 tw-px-2 tw-py-0.5 tw-rounded tw-border tw-border-solid tw-border-emerald-500/20 tw-font-mono" : "tw-text-rose-500 tw-bg-rose-500/10 tw-px-2 tw-py-0.5 tw-rounded tw-border tw-border-solid tw-border-rose-500/20 tw-font-mono";
      arrowColor = "tw-text-iron-600";
      wrapperClasses = "tw-ml-0.5 tw-flex tw-items-center tw-gap-2";
      valueClasses = "tw-text-sm tw-font-bold tw-tracking-tight";
    }
  }
  const t4 = wrapperClasses;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      animationDuration: "2s"
    };
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const t6 = `drop-vote-progress-${current}-${projected}`;
  const t7 = `tw-flex-shrink-0 ${compact ? "tw-size-2" : "tw-size-2.5"} ${arrowColor}`;
  let t8;
  if ($[1] !== t7) {
    t8 = <FontAwesomeIcon icon={faArrowRight} className={t7} />;
    $[1] = t7;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const t9 = `${valueClasses} ${color}`;
  let t10;
  if ($[3] !== projected) {
    t10 = formatNumberWithCommas(projected);
    $[3] = projected;
    $[4] = t10;
  } else {
    t10 = $[4];
  }
  let t11;
  if ($[5] !== t10 || $[6] !== t9) {
    t11 = <span className={t9}>{t10}</span>;
    $[5] = t10;
    $[6] = t9;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== t11 || $[9] !== t6 || $[10] !== t8 || $[11] !== wrapperClasses) {
    t12 = <span className={t4} style={t5} data-tooltip-id={t6}>{t8}{t11}</span>;
    $[8] = t11;
    $[9] = t6;
    $[10] = t8;
    $[11] = wrapperClasses;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const t13 = `drop-vote-progress-${current}-${projected}`;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    };
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== projected) {
    t15 = formatNumberWithCommas(projected);
    $[14] = projected;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t13 || $[17] !== t15 || $[18] !== tooltipLabel) {
    t16 = <Tooltip id={t13} place="top" offset={8} opacity={1} style={t14}>{tooltipLabel}: {t15}</Tooltip>;
    $[16] = t13;
    $[17] = t15;
    $[18] = tooltipLabel;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t12 || $[21] !== t16) {
    t17 = <>{t12}{t16}</>;
    $[20] = t12;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  return t17;
}